import api from '@pray/shared/utils/api';

export async function getPrayRadioDailyItems({
  artistId,
  dailySeriesId,
  type,
  startDate,
  endDate,
  userTimezone,
  includeArtistItems,
}: {
  artistId: string;
  dailySeriesId?: string;
  type?: string;
  startDate?: string;
  endDate?: string;
  userTimezone?: string;
  /** Also return items OWNED by the artist inside shared series (adds item_artist_id per row). */
  includeArtistItems?: boolean;
}) {
  if (!artistId) throw Error('Artist ID is required');

  const params = new URLSearchParams();
  if (dailySeriesId) params.set('dailySeriesId', dailySeriesId);
  if (type) params.set('type', type);
  if (startDate) params.set('startDate', startDate);
  if (endDate) params.set('endDate', endDate);
  if (userTimezone) params.set('userTimezone', userTimezone);
  if (includeArtistItems) params.set('includeArtistItems', 'true');

  const url = `/web/studio/artists/${artistId}/daily-items`;
  const queryString = params.toString();
  const response = await api.executeGetRequest(queryString ? `${url}?${queryString}` : url);

  return response.data;
}
